module.exports = __webpack_public_path__ + "6c74e07c57b9bc20f774f98f4f795c7d.pdf";